import { all, fork } from 'redux-saga/effects';
import { watchSaveCompanyTasksSaga } from './save-company-tasks';
import { watchSaveHomeResponseSaga } from './save-home-response';
export const homeRootSaga = function*() {
    yield all([
        fork(watchSaveCompanyTasksSaga),
        fork(watchSaveHomeResponseSaga)
    ]);
};
